module.exports = __webpack_public_path__ + "img/svg/selected-box-overlay.e59a6391a643d6d95310edeccb1000a0.svg";